module.exports = __webpack_public_path__ + "static/media/025.db50cc6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/025.jpg
// module id = 322
// module chunks = 0